import React, { useEffect, useState, useContext } from 'react';
import { toast } from 'react-toastify';
import { FormContextProvider } from '@sw-sw/lib-form';
import FolderModal from './FolderModal';
import {tenantDocTypesApi} from '../../../utils/api/docTypes';
import AppContext from '../../../contexts/AppContext';

const FoldersTab = () => {

  const appStore = useContext(AppContext);
  const user = appStore.get('user');
  const [systemFolders,setSystemFolders] = useState<any>([]);

  const [customFolders, setCustomFolders] = useState<any>([]);

  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState<{ id: number; name: string } | null>(null);

   const fetchTenantFolders = async () => {
      try {
        const response = await tenantDocTypesApi.get(user.tenantId);

        if (response) {
          const folderNames = response.filter((data:any) => !data.is_custom && !['Fixed Details', 'Fixed Details Project','Active Site Maps'].includes(data.doc_type?.name)).map((data:any) => data.doc_type);
          const customFolderNames = response.filter((data:any) => data.is_custom).map((data:any) => data.doc_type);

          setSystemFolders(folderNames);
          setCustomFolders(customFolderNames);
        }

      } catch (error) {
        console.error('Error fetching system folders:', error);
        toast.error('Failed to load system folders');
      }
    };

  useEffect(() => {   

    fetchTenantFolders();
   
  }, []);

  const handleCreateNewFolder = () => {
    setIsEdit(false);
    setSelectedFolder(null);
    setShowModal(true);
  };

  const handleEditFolder = (folder: { id: number; name: string }) => {
    setIsEdit(true);
    setSelectedFolder(folder);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setIsEdit(false);
    setSelectedFolder(null);
  };

  const handleSubmitFolder = async (folderData: { id?: number; name: string }) => {
    if (isEdit && folderData.id) {
      // Update existing folder

      await tenantDocTypesApi.update(user.tenantId, folderData.id.toString(), {
        name: folderData.name,
      });

      await fetchTenantFolders();
    
      toast.success('Folder updated successfully');
    } else {
      // Create new folder

      await tenantDocTypesApi.create(user.tenantId, {
        name: folderData.name,
        is_custom: true,
      });

      await fetchTenantFolders();
      toast.success('Folder created successfully');
    }
    handleCloseModal();
  };

  const handleDeleteFolder = async (folderId: number) => {

    await tenantDocTypesApi.delete(user.tenantId, folderId.toString());

    await fetchTenantFolders();

    toast.success('Folder deleted successfully');
    handleCloseModal();
  };

  return (
    <>
      <div className='folders-tab'>
        <div className='folders-section'>
          <h4 className='section-title'>System Folders</h4>
          <div className='folders-list'>
            {systemFolders.map((folder:any, index:any) => (
              <div key={index} className='folder-item'>
                {folder.name}
              </div>
            ))}
          </div>
        </div>

        <div className='folders-section'>
          <h4 className='section-title'>Custom Folders</h4>
          <div className='custom-folders-list'>
            {customFolders.map((folder:any) => (
              <div key={folder.id} className='custom-folder-item'>
                <span className='folder-name'>{folder.name}</span>
                <div className='folder-actions'>
                  <button
                    className='action-icon edit-icon'
                    onClick={() => handleEditFolder(folder)}
                    title='Edit'
                  >
                    <i className='fa fa-pencil' aria-hidden='true' />
                  </button>
                  <button
                    className='action-icon delete-icon'
                    onClick={() => handleEditFolder(folder)}
                    title='Delete'
                  >
                    <i className='fa fa-trash' aria-hidden='true' />
                  </button>
                </div>
              </div>
            ))}
          </div>
          <button className='create-button' onClick={handleCreateNewFolder}>
            <span className='plus-icon'>+</span>
            Create New Folder
          </button>
        </div>
      </div>

      {showModal && (
        <FormContextProvider>
          <FolderModal
            show={showModal}
            isEdit={isEdit}
            folder={selectedFolder}
            onClose={handleCloseModal}
            onSubmit={(folderData) => handleSubmitFolder(folderData)}
            onDelete={handleDeleteFolder}
          />
        </FormContextProvider>
      )}
    </>
  );
};

export default FoldersTab;
